/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { WarningMessage } from '../Utils.js';
import { PluginCommands } from 'molstar/lib/mol-plugin/commands';
import { AxiosSetstorageStructure } from './indeep_states'
import { useIsLoaded, updateIsLoaded } from './HookStateUpdate.jsx';
import { ExportButton } from './ExportButtons.jsx';

export function ButtonExportState(props) {
  const isLoaded = useIsLoaded();
  let handleButtonClick = async () => {
    PluginCommands.State.Snapshots.DownloadToFile(props.plugin, { type: 'json' });
  }
  return (
    <ExportButton isloaded={ isLoaded } handle={ handleButtonClick } />
    
  )
}

export const ButtonImportState = forwardRef((props, ref) => {
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  //const [isInputEnabled, setIsInputEnabled] = useState(false);

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };


  const handleSubmission = async () => {
    var reader = new FileReader();
    reader.readAsText(selectedFile);
    reader.onload = function (pEvent) {
      var vContent = pEvent.target.result;
      var indeepstatejson = JSON.parse(vContent);
      const transforms = indeepstatejson.entries.map(trf => trf.snapshot.data.tree.transforms);
      for (let i = 0; i < transforms[0].length; i++) {
        const params = transforms[0][i].params;
        if (params && params.hasOwnProperty('url')) {
          const file = params.url.split('media/')[1];
          AxiosSetstorageStructure(file);
        }
      }
    }
    if (isFilePicked) {
      PluginCommands.State.Snapshots.OpenFile(props.plugin, { file: selectedFile });
      updateIsLoaded(true);
      document.getElementById("analysis").scrollIntoView({behavior: "smooth"});
    } else {
      WarningMessage('Select an InDeep-Net state file');
    }
  };

  useImperativeHandle(ref, () => ({
    handleSubmission, 
  }));

  useEffect(() => {
    props.setIsInputEnabled(isFilePicked);
  }, [isFilePicked, props]);

  return (
    <div className= "px-4">
      <h3 className="text-md font-semibold whitespace-nowrap dark:text-gray-50">Select an InDeep<sup>Net</sup> file</h3>
      <div id="fileid" className="flex flex-row">
        <input className="h-full w-full rounded-[7px] border bg-blue-300 hover:bg-blue-400 py-2 px-4 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700
hover:file:bg-violet-100" type="file" name="file" onChange={changeHandler} accept=".molj" />
      </div>
    </div>

  )
})